import { Alert } from "@itandi/itandi-bb-ui";
import type React from "react";
import { ProgressBar } from "react-bootstrap";
import Styles from "./ReportImageUploadPanel.module.scss";
import { TopArea } from "./TopArea";

type Props = {
	deleting: boolean;
	handleDrop: (files: File[]) => Promise<void>;
	progress: number;
	uploading: boolean;
};

export const ReportImageUploadPanel: React.FC<Props> = ({
	uploading,
	deleting,
	progress,
	handleDrop
}: Props) => (
	<>
		{uploading ? (
			<div className={Styles.ProgressBar}>
				<p className={Styles.Message}>
					<Alert variant="warning">
						現在画像をアップロード中です。
						<br />
						画面を移動すると、アップロードが正常に完了しない場合があります。
					</Alert>
				</p>
				<ProgressBar label={`${progress}%`} now={progress} />
			</div>
		) : null}
		{deleting ? (
			<div className={Styles.DeleteProgressBar}>
				<p className={Styles.Message}>
					<Alert variant="warning">
						現在画像を削除中です。
						<br />
						画面を移動すると、削除が正常に完了しない場合があります。
					</Alert>
				</p>
				<ProgressBar label={`${progress}%`} now={progress} />
			</div>
		) : null}
		{!deleting && !uploading && <TopArea handleDrop={handleDrop} />}
	</>
);
